import { IPayrollsForPrintResponse } from "Dashboard/scenes/HumanResources/domain/IPayrollsForPrintResponse";
import { FormatDateShort, MonthNumberToText } from "utils/dateUtils";
import { FormatNumber, FormatNumberOrNull, FormatNumberWithUnitOrNull } from "utils/numberUtils";

interface IProps {
  month: number;
  year: number;
  payrolls?: IPayrollsForPrintResponse;
}

const PrintSalaries = (props: IProps) => {

  return (
    <div className="print-salaries">
      <div className="salaries-date positionFixed">
        <label>{MonthNumberToText(props.month)}</label>
        <label>{props.year}</label>
      </div>
      <div className="salary-content">
        {props.payrolls?.payrolls &&
          props.payrolls.payrolls.map((payroll, index) => (
            <div key={index} className={`single-salary-print${index % 3 === 2 ? ' page-break' : ''}`}>
              <h1>{payroll.employeeName}</h1>
              <p>{payroll.role}</p>
              <table>
                <tbody>
                  <tr>
                    <th>br.sati</th>
                    <th>din/sat</th>
                    <th>OSNOVNA ZARADA</th>
                    <th>na račun</th>
                    <th>obračun</th>
                    <th>datum isp.</th>
                    <th>ispl / troš</th>
                  </tr>
                  <tr>
                    <td>
                      <div className="empty">
                        <span className="single-salary-in-input-label align-right">
                          {payroll.hourlyRateNames?.[0]}:
                        </span>
                        <span className="single-salary-rate-value align-left">
                          {FormatNumberOrNull(payroll.hourlyWork?.[0]?.hours, {
                            minimumFractionDigits: 0, maximumFractionDigits: 2
                          })}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div className="empty">
                        {FormatNumberOrNull(payroll.hourlyWork?.[0]?.rate)}
                      </div>
                    </td>
                    <td>
                      <div className="empty blue">
                        {FormatNumber(payroll.basicSalary)}
                      </div>
                    </td>
                    <td>
                      <div className="empty">
                        {FormatNumber(payroll.paidByBank)}
                      </div>
                    </td>
                    <td>
                      <div className="empty green">
                        {FormatNumber(payroll.paidByHand)}
                      </div>
                    </td>
                    <td>
                      <div className="empty">
                        {FormatDateShort(payroll.paidOnDate)}
                      </div>
                    </td>
                    <td>
                      <div className="empty">
                        {payroll.paidExpenses[0] && (
                          <>
                            {FormatNumberOrNull(payroll.paidExpenses[0].amount)}
                            <span className="single-salary-in-input-label align-left">
                              {payroll.paidExpenses[0].note}
                            </span>
                          </>)}
                      </div>
                    </td>
                  </tr>
                  {Array.from(
                    Array(Math.max(10, payroll.hourlyWork.length, payroll.paidExpenses.length))
                      .keys()).filter(index => index !== 0).map(index => (
                        <tr key={index}>
                          <td>
                            {payroll.hourlyWork?.[index] ? (
                              <div className="empty">
                                <span className="single-salary-in-input-label align-right">
                                  {payroll.hourlyRateNames?.[index]}:
                                </span>
                                <span className="single-salary-rate-value align-left">
                                  {FormatNumberOrNull(payroll.hourlyWork?.[index]?.hours, {
                                    minimumFractionDigits: 0, maximumFractionDigits: 2
                                  })}
                                </span>
                              </div>
                            ) : <></>}
                          </td>
                          <td>
                            {payroll.hourlyWork?.[index] ? (
                              <div className="empty">
                                {FormatNumberOrNull(payroll.hourlyWork?.[index]?.rate)}
                              </div>) : <></>}
                          </td>
                          {index === 2 ? (
                            <>
                              <td className="span-two-columns">
                                <span className="single-salary-item-label align-right">UKUPNO ZARADIO: </span>
                                <span className="single-salary-item-value">
                                  {FormatNumber(payroll.totalAmountEarned)}
                                </span>
                              </td>
                              <td className="span-three-columns-and-rows">
                                <div className="single-salary-item-note">
                                  {payroll.note.split("\n").filter(line => line).map((line, index) => (
                                    <p key={index}>
                                      {line}
                                      <br />
                                    </p>
                                  ))}
                                </div>
                              </td>
                            </>
                          )
                            : index === 3 ? (
                              <td className="span-two-columns">
                                <span className="single-salary-item-label align-right">bonus: </span>
                                <span className="single-salary-item-value">
                                  {FormatNumber(payroll.bonus)}
                                </span>
                              </td>
                            )
                              : index === 4 ? (
                                <td className="span-two-columns">
                                  <span className="single-salary-item-label align-right">prevoz: </span>
                                  <span className="single-salary-item-value">
                                    {FormatNumber(payroll.travelExpenses)}
                                  </span>
                                </td>
                              )
                                : index === 5 ? (
                                  <td className="span-two-columns">
                                    <span className="single-salary-item-label align-right">korekcija: </span>
                                    <span className="single-salary-item-value">
                                      {FormatNumber(payroll.correction)}
                                    </span>
                                  </td>
                                )
                                  :
                                  <><td></td><td></td></>}
                          <td></td>
                          <td></td>
                          <td>
                            {payroll.paidExpenses?.[index] !== undefined ? (
                              <div className="empty">
                                {FormatNumberOrNull(payroll.paidExpenses?.[index].amount)}
                                <span className="single-salary-in-input-label align-left">
                                  {payroll.paidExpenses?.[index].note}
                                </span>
                              </div>
                            ) : <></>}
                          </td>
                        </tr>
                      ))}

                </tbody>
              </table>
              <div className="single-salary-counters-container">
                <div className="single-salary-counters-column">
                  <span>
                    <div>{FormatNumberOrNull(payroll.regularBreakfasts)}</div>doručak
                  </span>
                  <span>
                    <div>{FormatNumberOrNull(payroll.regularLunches)}</div>ručak
                  </span>
                  <span>
                    <div>{FormatNumberOrNull(payroll.regularDinners)}</div>večera
                  </span>
                  <span>
                  </span>
                </div>

                <div className="single-salary-counters-column">
                  <span>
                    <div>{FormatNumberOrNull(payroll.cashBreakfasts)}</div>keš doručak
                  </span>
                  <span>
                    <div>{FormatNumberOrNull(payroll.cashLunches)}</div>keš ručak
                  </span>
                  <span>
                    <div>{FormatNumberOrNull(payroll.cashDinners)}</div>keš večera
                  </span>
                  <span>
                  </span>
                </div>

                <div className="single-salary-counters-column">
                  <span>
                    <div>{FormatNumberOrNull(payroll.vacationDays)}</div>dana odmora
                  </span>
                  <span>
                    <div>{FormatNumberOrNull(payroll.sickLeaveDays)}</div>dana bolovanja
                  </span>
                  <span>
                    <div>{FormatNumberWithUnitOrNull(payroll.effectiveKilometers, 'km')}</div>efektivno
                  </span>
                  <span>
                    <div>{FormatNumberWithUnitOrNull(payroll.effectiveHours, 'sati')}</div>efektivno
                  </span>
                </div>
              </div>
            </div>
          ))}
      </div>
      <div className="total">
        ukupno<label>{props.payrolls?.payrolls.length}</label>
      </div>
    </div>
  );
};

export default PrintSalaries;
